import '@/assets/css/global.css'
import '@/assets/css/ui.css'

import Vue from 'vue'
import App from './index.vue'

import router from '@/components/router'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// Toast
import Toast from '@/components/Toast'
Vue.prototype.$toast = Toast

let mainApp = null;

import '@/directives/index'

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
  ops: {
    rail: {
        opacity: 0.6,
        background : '#f3d2c5',
        size: '12px',
        gutterOfSide : '0px',
    },
    bar: {
        background: '#d33d27',
        keepShow : true,
        size: '12px',
    }
  }, // 在这里设置全局默认配置
  name: 'vuescroll' // 在这里自定义组件名字，默认是vueScroll 
});

//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
//引入样式
// import style (>= Swiper 6.x)
import 'swiper/dist/css/swiper.min.css'
 
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

import {$get,$post} from "@/assets/js/axios.http.js"
Vue.prototype.$get = $get
Vue.prototype.$post = $post

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL
Vue.prototype.$queryArea = GLOBAL.queryArea;

//ajxa_map
globalThis.ajax_url_map = GLOBAL.ajax_url_map;

//store
import store from "@/assets/js/store.js";
Vue.prototype.$store = store;

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;


//FREE
import Free_login from '@/assets/js/freeLogin.js';

//login
import mslogin from '@/assets/js/msLogin.js';
Vue.prototype.$mslogin = mslogin;
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login;

//user_info
import User_info from '@/components/userinfo.vue';
Vue.component('user-info', User_info);

//rec
import Rec_view from '@/components/recommend.vue';
Vue.component('rec-view', Rec_view);

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem);

//utils
import utils from '@/assets/js/utils.js';
Object.keys(utils).forEach(key => {
  Vue.prototype[key] = utils[key]
})

Vue.prototype.$update_evt = function (data) {
  mainApp.user_init();
};

Vue.prototype.$task_render = function (data) {
    mainApp.task_init();
};

Vue.prototype.$reload = function (data) {
  mainApp.$refs.app.reload();
};

Vue.prototype.$loading = function(page){
  mainApp.$refs.app.addLoading();
};

Vue.prototype.$loading_close = function(page){
  mainApp.$refs.app.isCloseLoading();
};

//destoryLoading
Vue.prototype.$loading_destory = function(page){
  mainApp.$refs.app.destoryLoading();
};

Vue.prototype.$reflash = function(page){
  //console.log(mainApp.$refs.app.$router)
  mainApp.$refs.app.$router.push({ name: page, params: { _r : +new Date() }});
};

Vue.prototype.$clear_code = function(id,type){
  mainApp.$refs.app.code = '';
};

Vue.prototype.$query_task = function(tid){
    return mainApp.$store.state.task.filter((ele)=>{ return ele.taskNo == tid })[0];
};

Vue.prototype.$help_cut = function(id){
  mainApp.help_cut(id);
}

mainApp = new Vue({
    el: '#app',
    router,
    components: {
      App
    },
    template: '<App ref="app" :ready="ready" :ua="ua" :evt_info="evt_info" :login="login"/>',
    data() {
      return {
        ua: {},
        evt_info: {},
        code: '',
        share : '',
        name: null,
        login: 0, //登陆
        aid: 0, //大区id
        account_type: 'pc',
        isLoading: false,
        ready: false, //通信阀门
        share_id : 'ME21',
        key : '', 
        token : '',
        account_change : false,        
      }
    },
    created() {
      var _this = this;

      let token = GLOBAL.getQueryVariable('authorization') || localStorage.getItem("token");
      _this.token = token;
      
      let code = GLOBAL.getQueryVariable('code') || localStorage.getItem("code");
      let share = GLOBAL.getQueryVariable('share') || localStorage.getItem("share");

      

      if(GLOBAL.getQueryVariable('code')){
        localStorage.setItem('code', code);
      }

      if(GLOBAL.getQueryVariable('share')){
        localStorage.setItem('share', share);
      }      
      
      this.key = code;
      this.share = share;

      if (token) {
        localStorage.setItem('token', token);
        _this.$store.commit("$_setToken", token);
      }

      window.history.pushState({}, 0, GLOBAL.domain);
   
      
    },
    mounted (){
        this.get_user_info();

        let url = GLOBAL.domain.indexOf('http')< 0 ? 'https:' + GLOBAL.domain : GLOBAL.domain;
        wx.wxInit({
          title: GLOBAL.wx_share_text.title, // 分享标题
          desc: GLOBAL.wx_share_text.desc, // 分享描述
          link: url, // 分享链接
          imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
        });         
    },
    methods: {
      get_user_info() {
        // 调用免登录接口，进行免登录验证
        //TODO 梦平台免登录
        let _this = this;

        this.ua.uid = this.ua.uid || 0;

        Free_login.free_login_lazy(
          this.$store.state.userinfo.accountid, {
            mplat: ajax_url_map.mplat,
            kd: ajax_url_map.free,
          },
          function (response) {
            if (typeof response !== 'undefined') {
              _this.token = response.data ? response.data : response;
              localStorage.setItem('token', _this.token);
              _this.$store.commit("$_setToken", _this.token);              
            }
            _this.user_init();

          }
        );       
      },      
      user_init (){
        this.$get(ajax_url_map.userinfo,{
            success : (data) => {
              this.$store.commit("$_setUserinfo", data.data);
              this.$store.commit("$_setLogin", 1);

              let uid_pre = localStorage.getItem("uid_pre");
              if(uid_pre != this.$store.state.userinfo.uid){
                //换号检测
                this.account_change = true;
                this.$store.commit("$_setPreUid", this.$store.state.userinfo.uid);
                localStorage.setItem('first', 0);
              }

              this.task_init();
              if(localStorage.getItem("code"))this.help_cut(this.key);
              if(localStorage.getItem("share"))this.$invite_apply({ code : this.share });              
            },
            error : (data) => {
                this.task_init();
                if(data.code != 401 && data.code != 402)this.$toast(data.message);
                //if(localStorage.getItem("code"))this.help_cut(this.key);

                if(data.data){
                  this.$store.commit("$_setUserinfo", data.data);
                  this.$store.commit("$_setLogin", 1);
                }
                if(data.code == 402 && !localStorage.getItem("code")){
                  this.$bind_modal();
                }
                else if(data.code == 402 && localStorage.getItem("code")){
                  this.$toast('请先绑定大区');
                  this.$bind_modal();
                }
                if(!this.$store.state.login && localStorage.getItem("code")){
                  mslogin.open();
                }
            },
        })
      },
      task_init(){
        this.$get(ajax_url_map.ticket_list,{
            success : (data) => {
                this.ready = true;
                this.$store.commit("$_setTicket", data.data);

                let first = localStorage.getItem("first");
                
                var offer_apply =  data.data.filter(function(e){                 
                  return e.state == 1
                })
              
                if(offer_apply.length && this.account_change && !localStorage.getItem("code"))return this.$welcome_modal({
                    shop_list :  data.data,
                });

                if(offer_apply.length && !this.account_change && !localStorage.getItem("code"))return this.$ticket_modal({
                  shop_list :  data.data,
                });                

            },
            error : (data) => {
                this.ready = true;
                data.data && this.$store.commit("$_setTicket", data.data);
            }
        })
      },
      help_cut(id){
        this.$post(ajax_url_map.help,{
          success : (data) => {
            this.$help_modal({ amt : data.data.amt , giftId : data.data.giftId });
            localStorage.setItem("code",'');
          },
          error : (data) => {
            this.$msg_modal({ text : data.message});
            localStorage.setItem("code",'');
          }
        },{
          id : id,
        })
      },
      get_ticket_info(){

      },      
    },
  })

